export const DEFAULT_LANGUAGE = "DEFAULT_LANGUAGE";

export const setDefaultLanguage = (payload) => {
  return {
    type: DEFAULT_LANGUAGE,
    payload,
  };
};
